import { call, put, select, takeLatest } from 'redux-saga/effects'

import { selectAuthToken } from '@store/auth'
import {
  fetchBrandFanGroupMembers,
  fetchBrandFanGroups,
  fetchBrandFanGroupsError,
  fetchBrandFanGroupsSuccess,
  IBrandFanGroup,
  selectBrandFanGroupsNextLink,
} from '@store/brandFans'
import { IHateoasLink } from '@store/index'
import { selectBrandFanGroupsLink } from '@store/me'
import { networkRequest } from '@utils'

export function* handleFetchBrandFanGroups(action: ReturnType<typeof fetchBrandFanGroups>) {
  try {
    const { isNext } = action.payload
    let brandFanGroupsLink: IHateoasLink = yield select(selectBrandFanGroupsLink)
    if (isNext) {
      brandFanGroupsLink = yield select(selectBrandFanGroupsNextLink)
    }
    const authToken: string = yield select(selectAuthToken)
    const { items, metadata, links } = yield call(
      networkRequest,
      brandFanGroupsLink.method,
      brandFanGroupsLink.href,
      undefined,
      authToken,
    )
    yield put(fetchBrandFanGroupsSuccess(items, metadata, links, isNext))

    if (Array.isArray(items)) {
      const brandFanGroups = items as IBrandFanGroup[]
      for (const brandFanGroup of brandFanGroups) {
        yield put(fetchBrandFanGroupMembers(brandFanGroup.id))
      }
    }
  } catch (error) {
    yield put(fetchBrandFanGroupsError(error))
  }
}

export function* watchBrandFanGroupsRequest() {
  yield takeLatest(fetchBrandFanGroups.type, handleFetchBrandFanGroups)
}
